export const sharedFlowObjectMessages = {
  en: {
    flowObjectDetail: {
        tasksLabel: 'Tasks',  // meaning "Tasks that are part of this workflow" - for the "Tasks" tab in FlowObjectDetail.vue
        actionsLabel: 'Actions',  // for the "Actions" tab in FlowObjectDetail.vue, meaning "Actions that can be taken on this workflow"
        summaryTabName: 'Summary',
        historyTabName: 'History',
        messagesTabName: 'Messages',
        messagesAreaSubtitle: 'A single discussion thread for everyone involved in this workflow.  Send and receive from here, or from your email account.',
    },
  },
  es: {
    flowObjectDetail: {
        tasksLabel: 'Tareas',
        actionsLabel: 'Acciones',
        summaryTabName: 'Resumen',
        historyTabName: 'Historial',
        messagesTabName: 'Mensajes',
        messagesAreaSubtitle: 'Un hilo de discusión único para todos los involucrados en este flujo de trabajo. Envíe y reciba desde aquí o desde su cuenta de correo electrónico.',
    },
  },
  pt: {
    flowObjectDetail: {
        tasksLabel: 'Tarefas',
        actionsLabel: 'Ações',
        summaryTabName: 'Resumo',
        historyTabName: 'Histórico',
        messagesTabName: 'Mensagens',
        messagesAreaSubtitle: 'Um único tópico de discussão para todos os envolvidos neste fluxo de trabalho. Envie e receba daqui ou da sua conta de e-mail.',
    },
  },
  'zh-Hans': {
    flowObjectDetail: {
        tasksLabel: '任务',
        actionsLabel: '操作',
        summaryTabName: '摘要',
        historyTabName: '历史',
        messagesTabName: '消息',
        messagesAreaSubtitle: '一个讨论线程，供所有参与此工作流的人使用。 从这里或从您的电子邮件帐户发送和接收。',
    },
  },
  'zh-Hant': {
    flowObjectDetail: {
        tasksLabel: '任務',
        actionsLabel: '操作',
        summaryTabName: '摘要',
        historyTabName: '歷史',
        messagesTabName: '訊息',
        messagesAreaSubtitle: '一個討論線程，供所有參與此工作流程的人使用。 從這裡或從您的電子郵件帳戶發送和接收。',
    },
  },
};
